import type { Version } from '@atlassian/jira-issue-shared-types/src/common/types/issue-type.tsx';
import { VersionStatus } from '../constants.tsx';
import type { AggVersionNode } from '../types/fields-type.tsx';

type VersionWithARI = { ari: string } & Version;

export const transformAggVersionToLegacyVersion = (
	version: Pick<AggVersionNode, 'versionId' | 'name' | 'description' | 'status' | 'id'>,
): VersionWithARI => ({
	id: version.versionId ?? '',
	name: version.name ?? '',
	description: version.description ?? '',
	archived: version.status === VersionStatus.ARCHIVED,
	released: version.status === VersionStatus.RELEASED,
	ari: version.id,
});
